(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      if (this.dataset.static === 'true') {
        this.classList.add('products-loaded');
        return;
      }

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            this.classList.add('products-loaded');
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-social-posts"] && !Shopify.designMode) return;
  try {
    
  const loadInstagramPosts = () => {
    if (window.instgrm?.Embeds) {
      window.instgrm.Embeds.process();
      return;
    }
    if (document.querySelector('script[data-fabtopia-instagram]')) return;
    const script = document.createElement('script');
    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;
    script.dataset.fabtopiaInstagram = 'true';
    script.addEventListener('load', () => window.instgrm?.Embeds.process());
    script.addEventListener('error', () => script.remove());
    document.head.appendChild(script);
  };
  const loadXPosts = section => {
    if (window.twttr?.widgets) {
      window.twttr.widgets.load(section);
      return;
    }
    if (document.querySelector('script[data-fabtopia-x]')) return;
    const script = document.createElement('script');
    script.src = 'https://platform.twitter.com/widgets.js';
    script.async = true;
    script.dataset.fabtopiaX = 'true';
    script.addEventListener('load', () => window.twttr?.widgets.load(section));
    script.addEventListener('error', () => script.remove());
    document.head.appendChild(script);
  };
  const observeSocialPosts = () => {
    document.querySelectorAll('[data-social-posts]:not([data-observed])').forEach(section => {
      section.dataset.observed = 'true';
      const track = section.querySelector('.product-social-posts__track');
      const controls = section.querySelectorAll('[data-social-direction]');
      const updateControls = () => controls.forEach(button => {
        button.disabled = Number(button.dataset.socialDirection) < 0
          ? track.scrollLeft <= 1
          : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      });
      controls.forEach(button => button.addEventListener('click', () => {
        const card = track.querySelector('.product-social-posts__card');
        const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        track.scrollBy({ left: distance * Number(button.dataset.socialDirection), behavior: 'instant' });
      }));
      track.addEventListener('scroll', updateControls, { passive: true });
      new ResizeObserver(updateControls).observe(track);
      updateControls();
      const labelFrames = () => section.querySelectorAll('iframe:not([title]), iframe[title=""]').forEach(frame => {
        frame.title = frame.closest('[data-embed-title]')?.dataset.embedTitle || section.getAttribute('aria-label') || 'Instagram';
      });
      new MutationObserver(labelFrames).observe(track, { childList: true, subtree: true });
      labelFrames();
      const loadPosts = () => {
        if (section.querySelector('.instagram-media')) loadInstagramPosts();
        if (section.querySelector('.twitter-tweet')) loadXPosts(section);
      };
      if (!('IntersectionObserver' in window)) {
        loadPosts();
        return;
      }
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          loadPosts();
          observer.disconnect();
        }
      }, { rootMargin: '300px' });
      observer.observe(section);
    });
  };
  observeSocialPosts();
  document.addEventListener('shopify:section:load', observeSocialPosts);

  } catch(e) { console.error(e); }
})();
})();
